/**
 * Enum values for what is currently being exported from cases table.
 */
export enum ExportType {
  // Cases as csv file of currently selected columns.
  CASES = 'cases',
  // Active arrests of cases as ETIS import files.
  ARRESTS = 'arrests',
}
